import axios from "axios";
import { createStore } from "redux";
import auth from "../store";
const store = createStore(auth);
axios.interceptors.response.use(undefined, function retryIntercept(er) {
  if (er.response.status === 401) {
    store.dispatch({ type: "AUTH_LOGOUT" });
  }
  return Promise.reject(er);
});
const Axios = axios;
export default Axios;
